/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Unlock_PlusInputs */

const en_btn_unlock_plus = /** @type {(inputs: Btn_Unlock_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe to Plus`)
};

const ar_btn_unlock_plus = /** @type {(inputs: Btn_Unlock_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اشترك في بلس`)
};

const de_btn_unlock_plus = /** @type {(inputs: Btn_Unlock_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus abonnieren`)
};

const es_btn_unlock_plus = /** @type {(inputs: Btn_Unlock_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscríbete a Plus`)
};

const fr_btn_unlock_plus = /** @type {(inputs: Btn_Unlock_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S’abonner à Forest Plus`)
};

const it_btn_unlock_plus = /** @type {(inputs: Btn_Unlock_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbonati a Plus`)
};

const ja_btn_unlock_plus = /** @type {(inputs: Btn_Unlock_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusに登録する`)
};

const ko_btn_unlock_plus = /** @type {(inputs: Btn_Unlock_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 구독`)
};

const pt_br_btn_unlock_plus = /** @type {(inputs: Btn_Unlock_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assine o Plus`)
};

const ru_btn_unlock_plus = /** @type {(inputs: Btn_Unlock_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписаться на Plus`)
};

const th_btn_unlock_plus = /** @type {(inputs: Btn_Unlock_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สมัครสมาชิก Plus`)
};

const tr_btn_unlock_plus = /** @type {(inputs: Btn_Unlock_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus'a Abone Ol`)
};

const zh_cn_btn_unlock_plus = /** @type {(inputs: Btn_Unlock_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`购买 Plus`)
};

const zh_tw_btn_unlock_plus = /** @type {(inputs: Btn_Unlock_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訂閱 Plus`)
};

/**
* | output |
* | --- |
* | "Subscribe to Plus" |
*
* @param {Btn_Unlock_PlusInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_unlock_plus = /** @type {((inputs?: Btn_Unlock_PlusInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Unlock_PlusInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_unlock_plus(inputs)
	if (locale === "ar") return ar_btn_unlock_plus(inputs)
	if (locale === "de") return de_btn_unlock_plus(inputs)
	if (locale === "es") return es_btn_unlock_plus(inputs)
	if (locale === "fr") return fr_btn_unlock_plus(inputs)
	if (locale === "it") return it_btn_unlock_plus(inputs)
	if (locale === "ja") return ja_btn_unlock_plus(inputs)
	if (locale === "ko") return ko_btn_unlock_plus(inputs)
	if (locale === "pt_br") return pt_br_btn_unlock_plus(inputs)
	if (locale === "ru") return ru_btn_unlock_plus(inputs)
	if (locale === "th") return th_btn_unlock_plus(inputs)
	if (locale === "tr") return tr_btn_unlock_plus(inputs)
	if (locale === "zh_cn") return zh_cn_btn_unlock_plus(inputs)
	return zh_tw_btn_unlock_plus(inputs)
});